import React from 'react';
import Navigation from '../../components/navigation'
import Layout from '../../components/index-layout'
import {Link} from 'react-router-dom'
import equipment_01 from './../../pic/equipment_01.jpg'
import equipment_02 from './../../pic/equipment_02.jpg'
import equipment_03 from './../../pic/equipment_03.jpg'
import equipment_04 from './../../pic/equipment_04.jpg'
import equipment_05 from './../../pic/equipment_05.jpg'
import equipment_31 from './../../pic/equipment01.jpg'
import equipment_32 from './../../pic/equipment02.jpg'
import equipment_33 from './../../pic/equipment03.jpg'
import './index.css'
export default class equipment extends React.Component {
    state = {
        picList:[],
        picIndex:0,
        coverIndex:0
    }
    componentWillMount(){
        var list = [equipment_01,equipment_05,equipment_03,equipment_04,equipment_02,equipment_32,equipment_31,equipment_33]
        this.setState({picList:list})
    }
    togglePic=(index)=>{
        this.setState({picIndex:index})
    }
    toggleCover=(index)=>{
        this.setState({coverIndex:index})
    }
    render(){
        return (
            <main>
                <Navigation tab="equipment"></Navigation>
                <div className="train_container equipment_container">
                    <div className="top">
                        <img src={this.state.picList[this.state.picIndex]} alt=""></img>
                        <div>
                            <p style={{fontSize:'22px'}}>器材知识</p>
                            <Link to="/equipment/detail/1"><p onMouseEnter={this.togglePic.bind(this,1)} style={{color:(this.state.picIndex == 1 ? '#FF5D38' : '#E6E9F0')}}>高贵的决斗艺术，这些运动装备不能少</p></Link>
                            <Link to="/equipment/detail/2"><p onMouseEnter={this.togglePic.bind(this,2)} style={{color:(this.state.picIndex == 2 ? '#FF5D38' : '#E6E9F0')}}>怎样穿好击剑鞋？</p></Link>
                            <Link to="/equipment/detail/3"><p onMouseEnter={this.togglePic.bind(this,3)} style={{color:(this.state.picIndex == 3 ? '#FF5D38' : '#E6E9F0')}}>剑戳在身上疼不疼？好的击剑服堪比防弹衣</p></Link>
                            <Link to="/equipment/detail/4"><p onMouseEnter={this.togglePic.bind(this,4)} style={{color:(this.state.picIndex == 4 ? '#FF5D38' : '#E6E9F0')}}>“好剑在手，天下我有”</p></Link>
                            <Link to="/equipment/detail/5"><p onMouseEnter={this.togglePic.bind(this,5)} style={{color:(this.state.picIndex == 5 ? '#FF5D38' : '#E6E9F0')}}>击剑手套臭了怎么办？</p></Link>
                            <Link to="/equipment/detail/6"><p onMouseEnter={this.togglePic.bind(this,6)} style={{color:(this.state.picIndex == 6 ? '#FF5D38' : '#E6E9F0')}}>为什么击剑不用透明的面罩？</p></Link>
                        </div>
                    </div>
                    <div className="equipment_middle">
                        <Layout title="击剑器材">
                            <div className="list">
                                <Link to="/equipment/1">
                                    <li>
                                        <img src={require('./../../pic/equipment01.jpg')} alt=""></img>
                                        <div>
                                            <p>击剑面罩</p>
                                            <p>击剑面罩由金属保护网和护颈组成，考虑到舒适度，内部垫有海绵，面罩后部装有固定的安全装置。</p>
                                        </div>
                                    </li>
                                </Link>
                                <Link to="/equipment/2">
                                    <li>
                                        <img src={require('./../../pic/equipment02.jpg')} alt=""></img>
                                        <div>
                                            <p>剑</p>
                                            <p>剑最易坏的是剑尖，一把剑好用与否最重要看剑尖的灵敏度，剑尖是整支剑里最“娇气”部分，所以不能刺硬的地方。</p>
                                        </div>
                                    </li>
                                </Link>
                                <Link to="/equipment/3">
                                    <li>
                                        <img src={require('./../../pic/equipment03.jpg')} alt=""></img>
                                        <div>
                                            <p>击剑服</p>
                                            <p>击剑服对运动员提供安全保护的夹克式外套，长袖，领口覆盖颈部，拉链必须置于持剑手远端一侧，并有面料覆盖，下摆必须遮盖裤子10厘米以上。</p>
                                        </div>
                                    </li>
                                </Link>
                            </div>
                        </Layout>
                    </div>
                    
                </div>
            </main>
        )
    }
};